import React from 'react'

import { CertificateType } from './certificate.types'

export const getCertificateColor = (type: CertificateType) => {
  if (!type) {
    return '#8080FF'
  }
  if (type === 'course_dsa_frontend_backend') {
    return '#E2B954'
  } else if (type.startsWith('community_')) {
    return '#C39586'
  }
  return '#8080FF'
}

export const MiniCertificate = (props: {
  title: string
  cuid: string
  type: CertificateType
}) => {
  const { title, cuid, type } = props
  return (
    <svg
      width="84"
      height="112"
      viewBox="0 0 84 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M83.25 42.1998V109.2C83.25 110.304 82.3546 111.2 81.25 111.2H2.75C1.64543 111.2 0.75 110.304 0.75 109.2V2.7998C0.75 1.69523 1.64543 0.799805 2.75 0.799805H42L83.25 42.1998Z"
        fill={getCertificateColor(type)}
      />
      <path
        opacity="0.4"
        d="M83.25 42.1998H44C42.8954 42.1998 42 41.3044 42 40.1998V0.799805L83.25 42.1998Z"
        fill="white"
      />
      <path
        d="M21.723 28.6665C21.3545 28.5889 20.9754 28.5441 20.6209 28.4268C19.7597 28.1423 18.9109 28.1441 18.055 28.4372C16.6367 28.9235 15.4944 28.5889 14.6437 27.3336C14.1389 26.5904 13.4176 26.1214 12.5529 25.8662C11.1381 25.4437 10.4517 24.5195 10.5041 23.0504C10.5338 22.1589 10.2438 21.3553 9.69713 20.6466C8.81156 19.5 8.7382 18.3498 9.65521 17.1825C10.27 16.3996 10.5146 15.5012 10.4971 14.5253C10.4727 13.201 11.1137 12.3457 12.38 11.956C13.3634 11.6542 14.1372 11.099 14.7258 10.2662C15.5083 9.15913 16.5616 8.83668 17.8541 9.27466C18.7956 9.59366 19.737 9.58676 20.6785 9.27293C21.9588 8.8453 23.026 9.11085 23.819 10.2317C24.4076 11.0628 25.1867 11.6215 26.1718 11.9129C27.4434 12.2905 28.1176 13.1372 28.0966 14.4546C28.0774 15.5702 28.4634 16.5169 29.1097 17.4083C29.7927 18.3516 29.7962 19.3448 29.1027 20.2914C28.4495 21.1812 28.1089 22.1382 28.1193 23.2538C28.1316 24.5057 27.522 25.3817 26.2626 25.7507C25.2181 26.0576 24.4251 26.6904 23.7876 27.5561C23.2898 28.2337 22.647 28.7079 21.723 28.6665ZM11.8735 18.7964C11.8298 22.8055 15.1136 26.149 19.1467 26.2025C23.2775 26.2576 26.6888 23.0331 26.7465 19.0189C26.8041 14.9443 23.5326 11.5853 19.4611 11.5404C15.2603 11.4956 11.9189 14.6908 11.8735 18.7964Z"
        fill="white"
      />
      <path
        d="M19.046 29.6739C18.2146 32.0017 17.4146 34.2399 16.543 36.6799C16.1413 36.2143 15.7832 35.8712 15.5107 35.4711C14.8976 34.571 14.1012 34.4451 13.1108 34.7521C12.5955 34.9107 12.0366 34.9314 11.3711 35.0331C12.1658 32.8122 12.9221 30.6947 13.6767 28.5789C13.771 28.3168 13.9108 28.172 14.1832 28.3668C15.6085 29.3825 17.2784 29.567 19.046 29.6739Z"
        fill="white"
      />
      <path
        d="M27.2351 35.0297C26.3076 34.8814 25.5041 34.8021 24.7268 34.6141C24.2255 34.4917 23.9304 34.6469 23.5863 34.9745C23.0815 35.4556 22.6832 36.3367 22.023 36.2591C21.7033 36.2212 21.5077 35.0935 21.2737 34.452C20.7636 33.0536 20.2746 31.6465 19.7575 30.2516C19.6126 29.8584 19.5602 29.6463 20.1244 29.6256C21.6195 29.5722 23.0605 29.2946 24.3286 28.4307C24.5312 28.2927 24.7862 28.091 24.9085 28.5324C24.9469 28.6703 25.0046 28.8014 25.0535 28.9359C25.7644 30.924 26.477 32.9122 27.2351 35.0297Z"
        fill="white"
      />
      <path
        opacity="0.7"
        d="M19.3434 12.8824C22.7337 12.8979 25.4044 15.5706 25.3817 18.9244C25.359 22.2472 22.6237 24.8768 19.2177 24.8527C15.8955 24.8268 13.2056 22.1352 13.2178 18.8434C13.23 15.5034 15.9374 12.8686 19.3434 12.8824Z"
        fill="white"
      />
      {title.split(' ').map((text: string, index: number) => (
        <text
          key={cuid + text}
          x="5"
          dy={115 - (title.split(' ').length - index) * 15}
          style={{
            fill: 'white',
            fontSize: '0.75rem',
            fontWeight: 'bold',
            letterSpacing: 0.5
          }}>
          {text}
        </text>
      ))}
    </svg>
  )
}
